/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitEntityStatsVulnerabilitiesSsl
 */
export interface MonitEntityStatsVulnerabilitiesSsl {
    /**
     * 
     * @type {number}
     * @memberof MonitEntityStatsVulnerabilitiesSsl
     */
    count?: number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MonitEntityStatsVulnerabilitiesSsl
     */
    valid?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MonitEntityStatsVulnerabilitiesSsl
     */
    invalid?: { [key: string]: any; };
}

/**
 * Check if a given object implements the MonitEntityStatsVulnerabilitiesSsl interface.
 */
export function instanceOfMonitEntityStatsVulnerabilitiesSsl(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityStatsVulnerabilitiesSslFromJSON(json: any): MonitEntityStatsVulnerabilitiesSsl {
    return MonitEntityStatsVulnerabilitiesSslFromJSONTyped(json, false);
}

export function MonitEntityStatsVulnerabilitiesSslFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityStatsVulnerabilitiesSsl {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'valid': !exists(json, 'valid') ? undefined : json['valid'],
        'invalid': !exists(json, 'invalid') ? undefined : json['invalid'],
    };
}

export function MonitEntityStatsVulnerabilitiesSslToJSON(value?: MonitEntityStatsVulnerabilitiesSsl | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'valid': value.valid,
        'invalid': value.invalid,
    };
}

